import React, { Component } from 'react'
import Web3 from 'web3';
import './css.css';
import utils from './../../library'
import { create, all } from 'mathjs'

const config= {
    number: 'BigNumber',                   
    precision: 64           
  }
  
  const math = create(all, config)


class TreeStaker extends Component {
constructor(props){
super()
    this.state={show:"stake"}
}

    componentDidMount() {
        if(this.props.show=="edit"){
           this.start()
        }
        if(this.props.show=="stake"){
            this.setState({show:"stake"})
       // this.loadStake(0)
        }
    }

    async start(){
        await this.setState({show:"edit"})
        await this.loadMyShops()
        await this.loadEdit()
    }

async loadMyShops(){
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_OWNERSHIPABI } = process.env;
        const { REACT_APP_OWNERSHIP } = process.env;
        const ownsership = new web3.eth.Contract(JSON.parse(REACT_APP_OWNERSHIPABI), REACT_APP_OWNERSHIP)   
        let owned=await ownsership.methods.owned(accounts[0],0).call()
        console.log("singleuserbook COUNT"+owned[1]);
        let myLeafs=""
        for(let i=0;i<owned[1];i++){
            let addr
            addr=await ownsership.methods.owned(accounts[0],i).call()
            console.log("-----------------------------------------------")
            console.log("singleuserbook MODULE ADDRESS: "+addr[0])
            const { REACT_APP_HAPPYBOXABI } = process.env;
            const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), addr[0]) 
            let count=0;
            for(let j=0;j<count+1;j++){
                let addrTicket
                let found=false
                try{
                    addrTicket=await happybox.methods.modules_list(j).call()
                console.log("singleuserbook modules_list> ",addrTicket)
                    found=true
                    count++
                }catch(e){ console.log("ERROR singleuserbook modules_list",e)}  
                if(found){ 
                    let code=0  
                    try{
                        const { REACT_APP_TICKETABI } = process.env;
                      
                    let module = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), addrTicket)
                    let codex=await module.methods.code().call()
                    code=codex
                    }catch(f){ console.log("singleuserbook codex",f)} 
                    let enabled=await happybox.methods.modules(addrTicket).call()
                    let t=false
                    if(code==4)t=true
                    if(code==7)t=true
                    if(code==9)t=true
                    if(t){
                        let labelName=addrTicket
                        try{
                            let metaName=await utils.loadMetaName(addrTicket)

                        if(metaName!=".")labelName=metaName
                        }
                        catch(e){}
                        myLeafs+="<option value='"+addrTicket+"'>"+labelName+"</option>"
                    }
        
                        console.log("singleuserbook MODULE ADDRESS: "+addrTicket)
                        
                }  
            }             
        }    
        document.getElementById("TreeStaker_shops_select").innerHTML=""
        document.getElementById("TreeStaker_shops_select").innerHTML=myLeafs 
    })
}

async shopToOwnedID(shop){
    let found=0
    await window.ethereum.enable().then(async function (accounts) {
        const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
        let prestakeT=await beans.methods.readStake(shop).call()
        let amount=await beans.methods.owner(accounts[0],0).call()

        for(let i=0;i<parseInt(amount[1]);i++){

            let addr=await beans.methods.owner(accounts[0],i).call()
   
            if(addr[5]==shop)found=i
        }
    })
    return found
}

    async stake(){
        window.ethereum.enable().then(async function (accounts) {
            const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER)
           let address=document.getElementById("TreeStaker_shops_select").value
           let stake=document.getElementById("TreeStaker_input_text_field_staking_amount").value
           let index=document.getElementById("TreeStaker_input_text_field_claiming_position").getAttribute("memory")
            beans.methods.stakeOnTopOf(address,""+(stake*1000000000000000000),index).send({gasLimit: '500000', from: accounts[0]})
        })
    }

    async unstake(){
        let shop=document.getElementById("TreeStaker_shops_select_unstake").value.split(",")[0]
     
        let unstaking=await this.shopToOwnedID(shop)
     
        window.ethereum.enable().then(async function (accounts) {
            const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER)
            beans.methods.unstake(unstaking).send({gasLimit: '500000', from: accounts[0]})
        })
    }

    async select_unstakeshop(){
        let t=document.getElementById("TreeStaker_shops_select_unstake").value
        let s=t.split(",")
        //alert(s[0]+" "+s[1])
        document.getElementById("TreeStakers_unstake_amount_staked").innerHTML="Staked: "+(s[1]/1000000000000000000)
    }

    async select_shop(){
        await window.ethereum.enable().then(async function (accounts) {   
            const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
            let shop=document.getElementById("TreeStaker_shops_select").value
            let prestakeT=await beans.methods.readStake(shop).call()
            let index=prestakeT[1]
            let prestake=math.divide(math.bignumber(prestakeT[0]),math.bignumber(1000000000000000000))
            let gene=await beans.methods.list(index).call()
            let total=document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML
            let due=math.evaluate(total+'-'+prestake)
            //if(gene[4]==shop)due=0
        
            if(due<0)due=0
            if(due==0)total=prestake
            document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML=prestake
            document.getElementById("TreeStaker_input_text_field_staking_amount").value=due
        })
    }

    async countdown(){
        window.ethereum.enable().then(async function (accounts) {
            const stakercontract = new web3.eth.Contract(periodicStakerABI, PERIODIC_STAKER)
            stakercontract.methods.open().send({gasPrice: '12345678', from: accounts[0]})

            window.open('https://etherscan.io/address/0x0d514b2f8e8009480edd0b1543a265e5b539b833')
        })
       
    }

    async scan_stakeNeeded(){
        window.ethereum.enable().then(async function (accounts) {
        const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
        let leafs = await beans.methods.leafs().call()

        let gene=await beans.methods.list(0).call()
        let gene_next=gene[1]
        let request=parseInt(document.getElementById("TreeStaker_input_text_field").value)
        let last_found=0;
        for(let i=0;i<leafs;i++){
        gene=await beans.methods.list(gene_next).call()
        if(gene[1]!=10000000000000000){
            if(i+1==request){
               
                let shop=document.getElementById("TreeStaker_shops_select").value
                let prestakeT=await beans.methods.readStake(shop).call()
                let prestake=math.bignumber(prestakeT[0])
                //let tot=math.evaluate(math.bignumber(gene[2])+math.bignumber(0.01))
                let stake_val=math.bignumber(gene[2])
                stake_val=math.add(stake_val,math.bignumber(10000000000000000))
                let total_to_stake=math.divide(stake_val,math.bignumber(1000000000000000000))
                prestake=math.divide(prestake,math.bignumber(1000000000000000000))
             
                let needed=total_to_stake
                let due=math.evaluate(total_to_stake+'-'+prestake)
                if(gene[4]==shop)due=0
       
                if(due<0)due=0
                if(due==0)total_to_stake=prestake
                document.getElementById("TreeStaker_input_text_field_claiming_position").setAttribute("memory",gene_next)
                document.getElementById("TreeStaker_input_text_field").value=i+1
                document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML=needed+" 🌈"
                document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=i+1
                document.getElementById("TreeStaker_input_text_field_staking_amount").value=due
                document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML=total_to_stake
                document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML=prestake
                i=leafs
            }else{
                last_found=(parseInt(gene[2])-0.01)
                document.getElementById("TreeStaker_input_text_field").value=i+1
                document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=i+1
                document.getElementById("TreeStaker_input_text_field_staking_amount").value="scanning..."
                document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML="scanning..."
                document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML="scanning..."
                document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML="scanning..."
                gene_next=gene[1]
            }
        }else{
            let shop=document.getElementById("TreeStaker_shops_select").value
                let prestakeT=await beans.methods.readStake(shop).call()
                let prestake=math.bignumber(prestakeT[0])
                prestake=math.divide(prestake,math.bignumber(1000000000000000000))
                //let tot=math.evaluate(math.bignumber(gene[2])+math.bignumber(0.01))

                last_found=math.divide(last_found,math.bignumber(1000000000000000000))

                let stake_val=math.bignumber(gene[2])
                stake_val=math.add(stake_val,math.bignumber(10000000000000000))
                let total_to_stake=math.divide(stake_val,math.bignumber(1000000000000000000))
                
                let due=math.evaluate(last_found+'-'+prestake)
                //if(due<0)last_found=0
                if(gene[4]==shop)due=0
                if(due<0)due=0


                document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML=prestake
                document.getElementById("TreeStaker_input_text_field_staking_amount").value=due
            document.getElementById("TreeStaker_input_text_field").value=i+1
            document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=i+1        
            i=leafs
            document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML=last_found
            document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML="from 0.01 🌈 to "+last_found+" 🌈"
        }
        }
    })
    }

    async scan_positionReached(){
        window.ethereum.enable().then(async function (accounts) {
        const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
        let leafs = await beans.methods.leafs().call()

        let gene=await beans.methods.list(0).call()
        let gene_next=gene[1]
        let requestAmount=parseInt(document.getElementById("TreeStaker_input_text_field_scanforamount").value*1000000000000000000)
        let last_found=0;
        for(let i=0;i<leafs;i++){
        gene=await beans.methods.list(gene_next).call()
        if(gene[1]!=10000000000000000){
            if(gene[2]<requestAmount){
                let shop=document.getElementById("TreeStaker_shops_select").value
                let prestakeT=await beans.methods.readStake(shop).call()
                let prestake=math.bignumber(prestakeT[0])
                //let tot=math.evaluate(math.bignumber(gene[2])+math.bignumber(0.01))
                let tot=math.add(gene[2],math.bignumber(10000000000000000))
                let due=math.evaluate(tot+'-'+prestake)
                if(gene[4]==shop)due=0
                if(due<0)due=0
                if(due==0)tot=prestake
             
                //document.getElementById("TreeStaker_input_text_field").value=i+1
                //document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML=tot+" 🌈"
                document.getElementById("TreeStaker_input_text_field_claiming_position").setAttribute("memory",gene_next)
                document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=i+1
                document.getElementById("TreeStaker_input_text_field_staking_amount").value=(due/1000000000000000000)
                document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML=(tot/1000000000000000000)
                document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML=(prestake/1000000000000000000)
                document.getElementById("TreeStakers_secondlabel_search_position").innerHTML="Pos: "+(i+1)
                i=leafs
            }else{
        
                last_found=(parseInt(gene[2])-0.01)
                //document.getElementById("TreeStaker_input_text_field").value=i+1
                document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=i+1
                document.getElementById("TreeStaker_input_text_field_staking_amount").value="scanning..."
                //document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML="scanning..."
                document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML="scanning..."
                document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML="scanning..."
                gene_next=gene[1]
            }
        }else{
       
            
            let shop=document.getElementById("TreeStaker_shops_select").value
                let prestakeT=await beans.methods.readStake(shop).call()
                let prestake=math.bignumber(prestakeT[0])
                //let tot=math.evaluate(math.bignumber(gene[2])+math.bignumber(0.01))
                let tot=math.add(gene[2],math.bignumber(10000000000000000))
                tot=document.getElementById("TreeStaker_input_text_field_scanforamount").value*1000000000000000000
                
                let due=math.evaluate(tot+'-'+prestake)
                if(gene[4]==shop)due=0
                if(due<0)due=0
                if(due==0)tot=prestake
                document.getElementById("TreeStaker_input_text_field_claiming_position").setAttribute("memory",1)
                
                document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML=(tot/1000000000000000000)
                document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML=(prestake/1000000000000000000)
            document.getElementById("TreeStaker_input_text_field_staking_amount").value=(due/1000000000000000000)
            document.getElementById("TreeStakers_secondlabel_search_position").innerHTML="POS: "+(i+1)
            document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=(leafs-1)
           // document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML=last_found+" 🌈"
       
       i=leafs
        }
        }
    })
    }
    
    
        async loadEdit() {
            window.ethereum.enable().then(async function (accounts) {
                let account=accounts[0];
                const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
                let total_stake = await beans.methods.total().call()
                document.getElementById("TreeStaker_Stake_amount").innerHTML=(total_stake/1000000000000000000)+" 🌈"

                let leafs = await beans.methods.leafs().call()
                document.getElementById("TreeStaker_containers_amount").innerHTML=(leafs-2)+" 🍱"

                //let my_stake = await beans.methods.stake(accounts[0]).call()/1000000000000000000
            
                //document.getElementById("MyStake_amount").innerHTML=my_stake+" 🌱"
            
                let gene=await beans.methods.list(0).call()
                let gene_next=gene[1]
                
                gene=await beans.methods.list(gene_next).call()
                let stake_val=math.bignumber(gene[2])
                stake_val=math.add(stake_val,math.bignumber(10000000000000000))
                let total_to_stake=math.divide(stake_val,math.bignumber(1000000000000000000))
                
              document.getElementById("TreeStaker_input_text_field_claiming_position").setAttribute("memory",gene_next)  
              document.getElementById("TreeStaker_input_text_field").value=1
              document.getElementById("TreeStaker_input_text_field_tot_amount").innerHTML=total_to_stake
              document.getElementById("TreeStaker_input_text_field_claiming_position").innerHTML=1
              document.getElementById("TreeStakers_secondlabel_stake_needed").innerHTML=total_to_stake+" 🌈"
              
               let Nowned=await beans.methods.owner(accounts[0],0).call()
           // alert(accounts[0]+" "+Nowned[1])
            let tot=0;
           // document.getElementById("TreeStakers_owned_containers_list").innerHTML=""
            
            let myLeafs=""
            for(let i=0;i<Nowned[1];i++){
  
                let owned=await beans.methods.owner(accounts[0],i).call()
                const leaf = document.createElement('div');
                leaf.className="TreeStaker_owned_leaf "+i
                leaf.innerHTML=owned[5]+" "+owned[4]

                let labelName=owned[5]
                        try{
                            let metaName=await utils.loadMetaName(owned[5])
    
                        if(metaName!=".")labelName=metaName
                        }
                        catch(e){}
                        if(parseInt(owned[4])>0){
            myLeafs+="<option value='"+owned[5]+","+owned[4]+"'>"+labelName+"</option>"
                tot+=parseInt(owned[4])
                if(document.getElementById("TreeStakers_unstake_amount_staked").innerHTML=="")
                document.getElementById("TreeStakers_unstake_amount_staked").innerHTML="Staked: "+(owned[4]/1000000000000000000)
               // document.getElementById("TreeStakers_owned_containers_list").appendChild(leaf)
                        }
            }

          
           document.getElementById("TreeStaker_shops_select_unstake").innerHTML=myLeafs
                
            document.getElementById("TreeStakerMyStake_amount").innerHTML=(tot/1000000000000000000)+" 🌈"
            let shop=document.getElementById("TreeStaker_shops_select").value
            let prestakeT=await beans.methods.readStake(shop).call()
            let prestake=math.bignumber(prestakeT[0])
            let total=math.add(gene[2],math.bignumber(10000000000000000))
            let due=math.evaluate(total+'-'+prestake)
            if(gene[4]==shop)due=0
            if(due<0)due=0
            if(due==0)total=prestake
            document.getElementById("TreeStaker_input_text_field_prestake_amount").innerHTML=(prestake/1000000000000000000)
          document.getElementById("TreeStaker_input_text_field_staking_amount").value=(due/1000000000000000000)
         
            })
        }

        async loadStake(pag) {
            window.ethereum.enable().then(async function (accounts) {
                let account=accounts[0];
                const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
                let leafs = await beans.methods.leafs().call()
                let top=(pag+1)*10
                if(top>leafs)top=leafs

                let gene=await beans.methods.list(0).call()
                let gene_next=gene[1]
                for(let i=0+(pag*10);i<top;i++){
                gene=await beans.methods.list(gene_next).call()
                if(gene[1]!=10000000000000000){
                    const leaf = document.createElement('div');
                    leaf.className="TreeStaker_leaf"
                    leaf.innerHTML=gene_next+" "+gene[4]+" "+gene[2]+" "+gene[0]+" "+gene[1]
                    //document.getElementById("TreeStakers_staking_list").appendChild(leaf)
                    gene_next=gene[1]

                    const { REACT_APP_TICKETABI } = await  process.env;
                    const door = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), gene[4]) 
                    let code= await door.methods.code().call()
                    let box= await door.methods.box().call()
                    const { REACT_APP_HAPPYBOXABI } = await  process.env;
                    const boxC = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), box) 
                    let master= await boxC.methods.master().call()
          
                    let codeIcon=getCodeIcon(code)

                    const { REACT_APP_METAABI } = await process.env;
                    const { REACT_APP_META } = await  process.env;
                    const metadata = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
                    
                    let mtdt=await metadata.methods.meta(gene[4]).call()
                    let back="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE"
                    if(mtdt.length>0){
                        console.log("MTDT",mtdt)
                        fetch(formatURL(mtdt)).then(response => response.json()).then(
                        response => {
                            console.log(JSON.stringify(response))
        
                            back=response[0]["image"]
                            //alert(back)
                            if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                            //document.getElementById("Shop_header_image").style.backgroundImage='url('+response[0]["image"]+')'
                            let container = document.createElement('div');
                            container.className = 'shop_container_minipanel';
                            let book = document.createElement('div');
                            book.className = 'book_icon';
                            book.innerHTML="📘"
                            let tree = document.createElement('div');
                            tree.className = 'TreeStaker_tree_icon';
                            tree.innerHTML=(gene[2]/1000000000000000000)+"xxx🌈"
                            let mainDiv = document.createElement('div');
                            let iDiv = document.createElement('div');
                            let backDiv = document.createElement('div');
                            let iname = document.createElement('div');
                            iDiv.id = 'shop_'+i;
                            iDiv.className = 'shop_link';
                            mainDiv.className = 'shop_maindiv dark darkblue';
                            backDiv.className = 'shop_backdiv';
                            iname.textContent=codeIcon+response[0]["name"];
                            iname.style.margin="100px 20px 0 0"
                            iname.style.fontSize="30px"
                            iname.style.float="right"
                            iDiv.style.backgroundImage='url('+back+')'
                            iDiv.style.backgroundSize='cover'
                            iDiv.appendChild(iname)
                            container.appendChild(mainDiv)
                            //if(master.toLowerCase()==accounts[0].toLowerCase())
                            container.appendChild(tree)
                            mainDiv.appendChild(backDiv)
                            mainDiv.appendChild(iDiv)
                            mainDiv.append(response[0]["description"])
                            mainDiv.addEventListener("click",  () => window.open("/smartshop/?shop="+gene[4]))
                            document.getElementById("book_board").appendChild(container)
           
                        })
                    }else{
                    let container = document.createElement('div');
                    container.className = 'shop_container_minipanel';
                    let book = document.createElement('div');
                    book.className = 'book_icon';
                    book.innerHTML="📘"
                    let tree = document.createElement('div');
                    tree.className = 'TreeStaker_tree_icon';
                    tree.innerHTML=(gene[2]/1000000000000000000)+"🌈"
                    let iDiv = document.createElement('div');
                    iDiv.id = 'shop_'+i;
                    iDiv.className = 'shop_link_empty dark darkblue';
                    let iname = document.createElement('div');
                    
                    iname.style.margin="27px 0 0 0"
                    let iIcon = document.createElement('div');
                    iIcon.style.margin="00px 0 0 10px"
                    iIcon.style.float="left"
                    iIcon.innerHTML=codeIcon
                    iIcon.style.fontSize="50px"
                    iname.innerHTML=gene[4]
                    iname.style.fontSize="20px"
                    container.appendChild(iDiv)
                    
                    //if(master.toLowerCase()==accounts[0].toLowerCase())
                    container.appendChild(tree)
                    iDiv.appendChild(iIcon)
                    iDiv.appendChild(iname)
                    iDiv.style.backgroundImage='url('+back+')'
                    iDiv.style.backgroundSize='cover'
                    iDiv.addEventListener("click", () => window.open("/smartshop/?shop="+gene[4]))
                    document.getElementById("book_board").appendChild(container)
                    }
                }
                if(gene[1]==10000000000000000)i=leafs
                }
if(0==1){
             gene=await beans.methods.list(0).call()
             gene_next=gene[1]
            for(let i=0;i<leafs;i++){
            gene=await beans.methods.list(i).call()

            const leaf = document.createElement('div');
            leaf.className="TreeStaker_leaf"
            leaf.innerHTML=gene_next+" "+gene[4]+" "+gene[2]+" "+gene[0]+" "+gene[1]
            document.getElementById("TreeStakers_staking_list").appendChild(leaf)
            gene_next=gene[1]


        }}
        
              
          
            
            })
        }

        async check_minMax(){
            if(document.getElementById("TreeStaker_input_text_field").value<1)
                document.getElementById("TreeStaker_input_text_field").value=1

                const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
                let leafs = await beans.methods.leafs().call()
            if(document.getElementById("TreeStaker_input_text_field").value>(parseInt(leafs)-1))
                document.getElementById("TreeStaker_input_text_field").value=(parseInt(leafs)-1)
        }

        async updateEdit(){
            if(this.state.show!=this.props.show){
                await this.setState({show:this.props.show})
                await this.loadMyShops()
                await this.loadEdit()

            }
        }

    render(){
        this.updateEdit()
        
        return ( 
    <div id="Staker_panel">
        {(this.props.show=="edit")?
        <>
        
        <div className="TreeStaker_panel dark darkblue text white">
        <div id="Staker_mainlabel" className="text white"><span id="stakecontract"  className="text white" aria-labelledby="jsx-a11y/accessible-emoji" role="img" onClick={() => jump()}>🎄 </span> Tree Staker Contract</div>  
            <div className="TreeStakerMystake_row">
                <div className="TreeStaker_Stake_label text white">💰 Staked: <span id="TreeStaker_Stake_amount" className="right text white">loading please wait... 🌈</span></div>            
            </div>
            <div className="clear"/>

            <div className="TreeStakerMystake_row">
                <div className="TreeStaker_Stake_label text white">🍱 Containers: <span id="TreeStaker_containers_amount" className="right text white">loading... 🍱</span></div>            
            </div>
            <div className="clear"/>

            <div className="TreeStakerMystake_row">
                <div id="Mystake_label" className="TreeStaker_Stake_label text white" onClick={() => this.unstake()}>🔓 Yours: <span id="TreeStakerMyStake_amount" className="right text white">loading... 🌈</span></div>            
            </div>
            <div className="clear"/>
        
            <div className="TreeStakerMystake_row text white">
                <div className="TreeStakers_label left text white">Stake needed for position: </div>
                <input type="text" id="TreeStaker_input_text_field" className="TreeStaker_input_text_field light lightblue text white" onKeyUp={() => this.check_minMax()} onKeyPress={() => this.check_minMax()}></input>
                <div id="TreeStakers_secondlabel_stake_needed" className="TreeStakers_secondlabel left text white"> ? 🌈 </div>
                <input type="button" className="TreeStaker_input_button light lightblue text white" value="🔍 scan" onClick={() => this.scan_stakeNeeded()}></input>


            </div>
            <div className="clear"/>
        
            <div className="TreeStakerMystake_row">
                <div className="TreeStakers_label left text white">Position reached staking 🌈:  </div>
                <input type="text" id="TreeStaker_input_text_field_scanforamount" className="TreeStaker_input_text_field light lightblue text white"></input>
                <div id="TreeStakers_secondlabel_search_position" className="TreeStakers_secondlabel left text white">pos: ?</div>
                <input type="button" className="TreeStaker_input_button light lightblue text white" onClick={() => this.scan_positionReached()} value="🔍 scan"></input>
            
            </div>

            <div id="TreeStaker_stake_row" className="TreeStakerMystake_row">
                <div className="TreeStakers_label_stake_on_shop left text white">Stake on Shop:  </div>
                <select type="text"  onChange={() => this.select_shop()} name="TreeStaker_shops_select" id="TreeStaker_shops_select" className="TreeStaker_shops_select light lightblue text white text white">
                    <option value="loading...">loading...</option>
                </select>
                <div className="TreeStakers_label left text white">Amount Bows to stake🌈:  </div>
                <input type="text" id="TreeStaker_input_text_field_staking_amount" className="TreeStaker_input_text_field light lightblue text white"></input>
                <div className="TreeStakers_label left text white">Prestaked 🌈:  </div>
                <div type="text" id="TreeStaker_input_text_field_prestake_amount" className="TreeStaker_input_text_field text white"></div>
                <div className="TreeStakers_label left text white">You reach 🌈:  </div>
                <div type="text" id="TreeStaker_input_text_field_tot_amount" className="TreeStaker_input_text_field text white"></div>
                
                <div className="TreeStakers_label left text white">Claim Leaderboard Position:  </div>
                <div type="text" id="TreeStaker_input_text_field_claiming_position" className="TreeStaker_input_text_field text white" memory="0x0"></div>
                <div className="clear"/>
                <input type="button" className="TreeStaker_input_button light lightblue text white"  onClick={() => this.stake()} value="🐘 stake"></input>
            
            </div>

            <div id="TreeStaker_stake_row" className="TreeStakerMystake_row">
                <div className="TreeStakers_label_stake_on_shop left text white">Unstake Shop:  </div>
                <select type="text"  onChange={() => this.select_unstakeshop()} name="TreeStaker_shops_select_unstake text white" id="TreeStaker_shops_select_unstake" className="TreeStaker_shops_select light lightblue text white">
                    <option value="loading...">loading...</option>
                </select>
                <div className="clear"/>
                <div className="TreeStakers_label left text white" id="TreeStakers_unstake_amount_staked"></div>
                <input type="button" className="TreeStaker_input_button_unstake light lightblue text white" onClick={() => this.unstake()} value="🐘 unstake"></input>
            
            </div>
            
            <div className="clear"/>
         
        </div>
        </>
        :
        <>
            <div className="clear"/>
            
            <div id="TreeStakers_staking_list" className="TreeStakers_staking_list left"></div>
            </> 
    }
    </div>
        );
    }


}

function getCodeIcon(code){
    let t="📖";
    if(code=="4")t="🎟️"
    if(code=="7")t="🎀"
    if(code=="9")t="💫"
    return t;
}

function jump(){
    window.open('https://etherscan.io/address/0x7d410AFA45377006A0F79Ae6157A6A873Bfa5567')
}

function countdown(block){
    window.open('https://etherscan.io/block/countdown/'+block)
}



function getAvatar(res){
    let avatar="👻";
    if(res.slice(-1)==="0")avatar="🐶";
    if(res.slice(-1)==="1")avatar="🐱";
    if(res.slice(-1)==="2")avatar="🐹";
    if(res.slice(-1)==="3")avatar="🐸";
    if(res.slice(-1)==="4")avatar="🐵";
    if(res.slice(-1)==="5")avatar="🐻";
    if(res.slice(-1)==="6")avatar="🐼";
    if(res.slice(-1)==="7")avatar="🐰";
    if(res.slice(-1)==="8")avatar="🐨";
    if(res.slice(-1)==="9")avatar="🐯";
    if(res.slice(-1)==="a")avatar="🦁";
    if(res.slice(-1)==="b")avatar="🐮";
    if(res.slice(-1)==="c")avatar="🐷";
    if(res.slice(-1)==="d")avatar="🐺";
    if(res.slice(-1)==="e")avatar="🐗";
    if(res.slice(-1)==="f")avatar="🐔";
    return avatar;
}

function getFamily(ress){
    let avatar="☠️";
    let res=ress.slice(-2)
    res = res.substring(0, 1);
    if(res.slice(-1)==="0")avatar="🐳";
    if(res.slice(-1)==="1")avatar="🦈";
    if(res.slice(-1)==="2")avatar="🐅";
    if(res.slice(-1)==="3")avatar="🐍";
    if(res.slice(-1)==="4")avatar="🐞";
    if(res.slice(-1)==="5")avatar="🐪";
    if(res.slice(-1)==="6")avatar="🦋";
    if(res.slice(-1)==="7")avatar="🐙";
    if(res.slice(-1)==="8")avatar="🐄";
    if(res.slice(-1)==="9")avatar="🐇";
    if(res.slice(-1)==="a")avatar="🐖";
    if(res.slice(-1)==="b")avatar="🐏";
    if(res.slice(-1)==="c")avatar="🐐";
    if(res.slice(-1)==="d")avatar="🦎";
    if(res.slice(-1)==="e")avatar="🐠";
    if(res.slice(-1)==="f")avatar="🦍";
    return avatar;
}

function formatURL(url){
    return("https://gateway.ipfs.io/ipfs/"+url);
  }


function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

let TREESTAKER="0x84B00e445e547aD1221d527DD99f99FbE2D39E78"
let TREESTAKER_ABI=[ { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [], "name": "leafs", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "list", "outputs": [ { "internalType": "uint256", "name": "prev", "type": "uint256" }, { "internalType": "uint256", "name": "next", "type": "uint256" }, { "internalType": "uint256", "name": "stake", "type": "uint256" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "container", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "mapped", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "owned", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_owner", "type": "address" }, { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "owner", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_container", "type": "address" } ], "name": "readStake", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_container", "type": "address" }, { "internalType": "uint256", "name": "_stake", "type": "uint256" }, { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "stakeOnTopOf", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "total", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "unstake", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" } ]
let periodicStakerABI=[ { "inputs": [ { "internalType": "address", "name": "tokenToStake", "type": "address" }, { "internalType": "address", "name": "mastr", "type": "address" } ], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": false, "internalType": "address", "name": "staker", "type": "address" } ], "name": "Staked", "type": "event" }, { "inputs": [ { "internalType": "uint256", "name": "freez", "type": "uint256" } ], "name": "freeze", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "freezeTime", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "lockTime", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "master", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "modules", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "modules_list", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "open", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "lock", "type": "uint256" } ], "name": "openDropping", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "new_master", "type": "address" } ], "name": "setMaster", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "new_module", "type": "address" }, { "internalType": "bool", "name": "set", "type": "bool" } ], "name": "setModule", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "stake", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "address", "name": "staker", "type": "address" } ], "name": "stakeNow", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "stakeNow", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "startLock", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "status", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "token", "outputs": [ { "internalType": "contract ERC20", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "total_stake", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "total_stakers", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "unstake", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "unstaker", "type": "address" } ], "name": "unstake", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" } ]
let ABI=[{"inputs":[{"internalType":"address","name":"proxy","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"subject","type":"address"},{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"checkOnERC721Received","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getProxy","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"subject","type":"address"},{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"forAll","type":"bool"},{"internalType":"bool","name":"approved","type":"bool"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"raiseApprovalEvent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"raiseTransferEvent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"_approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"proxy","type":"address"}],"name":"setProxy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"}]
let PERIODIC_STAKER="0x7d410AFA45377006A0F79Ae6157A6A873Bfa5567"
let ADDRESS="0x801F90f81786dC72B4b9d51Ab613fbe99e5E4cCD"
let BEANS="0x801F90f81786dC72B4b9d51Ab613fbe99e5E4cCD"
let uSD="0x44086035439E676c02D411880FcCb9837CE37c57"
let UNIFI="0x9E78b8274e1D6a76a0dBbf90418894DF27cBCEb5"
let ARTE="0x34612903Db071e888a4dADcaA416d3EE263a87b9"

const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")
//<InstaClaimer/>
//<LockDrop/>


export default TreeStaker